import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useReducer,
} from "react";

export type UIAPI = {};

export type UIData = {};

export type UIAction = {};

export const UIAPIContext = createContext({} as UIAPI);
export const UIDataContext = createContext({} as UIData);

export const UIProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("UIProvider render");

  const [data, dispatch] = useReducer((data: UIData, action: UIAction) => {
    switch (action) {
      default:
        return {};
    }
  }, {} as UIData);

  const api = useMemo<UIAPI>(() => {
    return {};
  }, []);

  return (
    <UIAPIContext.Provider value={api}>
      <UIDataContext.Provider value={data}>{children}</UIDataContext.Provider>
    </UIAPIContext.Provider>
  );
};

export const useUIAPI = () => useContext(UIAPIContext);
export const useUIData = () => useContext(UIDataContext);
